export const SIZES_SORT_ORDER: Array<string> = [
  'XXXS',
  'XXS/XS',
  'XXS',
  '2XS',
  'XS',
  'XS/S',
  'S',
  'S/M',
  'M',
  'M/L',
  'L',
  'L/X',
  'L/XL',
  'XL',
  'XXL',
  '2XL',
  'XL/XXL',
  'XXXL',
  '3XL',
  'XXXXL',
  '4XL',
  'XXXXXL',
  '5XL',
  '6XL',
  '7XL',
  '000',
  '00',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '18',
  '20',
  '22',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '44',
  '46',
  '48',
  '50',
  '24/6',
  '25/7',
  '26/8',
  '27/9',
  '28/10',
  '29/11',
  '30/12',
  '31/13',
  '32/14',
  '33/15',
  '34/16',
  '36/18',
  '28/71',
  '30/77',
  '32/82',
  '34/87',
  '36/92',
  '77/30',
  '79/31',
  '84/33',
  '87/34',
  '89/35',
  '92/36',
  '97/38',
  '102/40',
  '107/42',
  'O/S',
  'OneSize',
  // === second part of list are unused values but client wanted to add them, to the end of the first part list
  '1/2',
  '10.5',
  '10/28',
  '100',
  '104',
  '108',
  '10B',
  '10C',
  '11-14',
  '11.5',
  '11/16',
  '11/29',
  '112',
  '116',
  '12/30',
  '120',
  '124',
  '128',
  '12B',
  '12C',
  '13/31',
  '132',
  '14/32',
  '14B',
  '14C',
  '16B',
  '16C',
  '18/20',
  '18B',
  '18C',
  '2/3',
  '22/24',
  '22/4',
  '23/5',
  '24/6',
  '24/61',
  '25/7',
  '26/28',
  '26/67',
  '26/8',
  '27/9',
  '28/10',
  '28/71',
  '28/77',
  '29/11',
  '29/74',
  '3/4',
  '30/12',
  '30/32',
  '30/77',
  '31/13',
  '31/79',
  '32/14',
  '32/82',
  '33/15',
  '33/84',
  '34/16',
  '34/87',
  '35/17',
  '35/89',
  '36/18',
  '36/92',
  '37/94',
  '38/97',
  '39/99',
  '4/22',
  '4/5',
  '40/102',
  '42/107',
  '43',
  '44/112',
  '45',
  '46/117',
  '48/122',
  '4s/f',
  '5.5',
  '5/6',
  '52',
  '5s/f',
  '6-10',
  '6.5',
  '6/12',
  '6/24',
  '6/7',
  '6s/f',
  '7.5',
  '7/10',
  '7/25',
  '7/8',
  '71/28',
  '7s/f',
  '8.5',
  '8/26',
  '82/32',
  '88',
  '8s/f',
  '9.5',
  '9/27',
  '92',
  '96',
  '99',
  'Avg',
  'CAP',
  'DUO',
  'Ex Tall',
  'K 1/2',
  'L 1/2',
  '1SZE',
  'PACK',
  'POST',
  'PRONG',
  'SOCKET',
  'STUD',
  'Tall',
];

export const COLOURS_SORT_ORDER = [
  'Black',
  'Blue',
  'Brown',
  'Cream',
  'Green',
  'Grey',
  'Metallic',
  'Multi',
  'Navy',
  'Neutrals',
  'Nude',
  'Orange',
  'Pattern',
  'Pink',
  'Print',
  'Purple',
  'Red',
  'Stone',
  'White',
  'Yellow',
];

export const getSortedSizeLabels = (arr) => {
  if (!arr) return [];
  const options = arr.map((o) => {
    const sortOrder = SIZES_SORT_ORDER.indexOf(o.label);
    if (sortOrder !== null) {
      return {
        ...o,
        sortOrder,
      };
    }
    return null;
  });

  if (!options.length) return [];
  const uniqueOptions = options.filter((el) => el);
  if (!uniqueOptions.length) return [];

  return options.sort((a, b) => a.sortOrder - b.sortOrder);
};

export const sortArrayByLabel = (array) => {
  return [...array].sort((a, b) => {
    if (a?.label === 'swatch') {
      return 1;
    } else if (b?.label === 'swatch') {
      return -1;
    } else if (a?.label === '' || a?.label === undefined) {
      return 1;
    } else if (b?.label === '' || b?.label === undefined) {
      return -1;
    } else {
      return Number(a?.label) - Number(b?.label);
    }
  });
};
